import { SubItem } from '../../../types/sub-item.types';

export const COPY_ENTITIES = {
   Mass: 'Mass (g)',
   Volume: 'Volume (mm\u00B3)',
   Quantity: 'Quantity',
   Density: 'Density (kg/m\u00B3)',
   RecycledContent: 'Recycled content (%)',
   RenewableContent: 'Renewable content (%)',
   CompositionShare: 'Composition share (%)',
   ThreeDModelNo: '3D model no.',
} as const;

export type CopyEntity = keyof typeof COPY_ENTITIES;

export const ALL_COPY_ENTITIES: CopyEntity[] = Object.keys(COPY_ENTITIES) as CopyEntity[];

export const BE_ONLY_ALWAYS_COPIED_ENTITIES = ['Active', 'ClientCreated'] as const;
export type BeOnlyAlwaysCopiedEntity = typeof BE_ONLY_ALWAYS_COPIED_ENTITIES[number];

export const ALWAYS_COPIED_PREVIEW_ENTITIES = {
   MaterialGradeId: 'Material grade ID',
} as const;

export type AlwaysCopiedPreviewEntity = keyof typeof ALWAYS_COPIED_PREVIEW_ENTITIES;
export type PreviewEntity = CopyEntity | AlwaysCopiedPreviewEntity;

export const PREVIEW_ENTITY_LABELS: Record<PreviewEntity, string> = {
   ...COPY_ENTITIES,
   ...ALWAYS_COPIED_PREVIEW_ENTITIES,
};

export const ENTITY_FIELD_ACCESSOR: Record<PreviewEntity, keyof SubItem> = {
   Mass: 'mass',
   Volume: 'volume',
   Quantity: 'quantity',
   Density: 'density',
   RecycledContent: 'recycledContent',
   RenewableContent: 'renewableContent',
   CompositionShare: 'compositionShare',
   ThreeDModelNo: 'threeDModelNo',
   MaterialGradeId: 'materialGradeId',
};

export type ExistingMode = 'overwrite' | 'fill-missing' | 'skip';
